import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
// import { HorizonLogo } from "components/icons/Icons";
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {
  //   Chakra color mode
  let logoColor = useColorModeValue("navy.700", "white");

  return (
    <Flex align="center" direction="column">
      {/* <HorizonLogo h='26px' w='175px' my='32px' color={logoColor} /> */}
      <h1 color={logoColor} style={{ fontWeight: "750", fontSize: "32px" }}>
        BOOK APP
      </h1>

      <HSeparator mb="20px" />
    </Flex>
  );
}

export default SidebarBrand;
